module.exports = __webpack_public_path__ + "img/1_1.d91ba63c.jpg";